var en = function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var number = function (value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error("Can't apply offset:" + offset + ' to argument `' + name + '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
};
var plural = function (value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  return key in data ? data[key] : data.other;
};
var select = function (value, data) {
  return {}.hasOwnProperty.call(data, value) ? data[value] : data.other;
};

module.exports = {
  generic: {
    results: function(d) { return plural(d.copy, 0, en, { "0": "0点", "1": "1点", other: number(d.copy, "copy") + "点" }); }
  },
  search: {
    title: function(d) { return "検索結果:"; },
    results: function(d) { return "“" + d.searchTerm + "”"; }
  },
  product: {
    notStockedOnLine: function(d) { return "申し訳ございません。この商品は購入できません"; },
    productCode: function(d) { return "商品コード"; },
    soldOut: function(d) { return "申し訳ございません。この商品は完売しました。ウィッシュリストに追加しておくと再入荷した際､お知らせいたします"; },
    buyableFalse: function(d) { return "申し訳ございません。この商品は購入できません"; },
    unavailableProduct: function(d) { return "申し訳ございません。この商品は購入できません"; },
    shippingRestriction: function(d) { return "申し訳ございません。この商品はご利用の国/地域ではお取り扱いしておりません"; },
    restrictedToEip: function(d) { return "申し訳ございません。この商品は完売しました。ウィッシュリストに追加しておくと再入荷した際にお知らせいたします"; },
    doNotForgetToAddToWishlistMessage: function(d) { return "ウィッシュリストに追加することをおすすめいたします"; },
    shippingRestrictionsNotificationMessage: function(d) { return "商品によってはお届けできない国/地域がございます [詳しく見る](/" + d.locale + "/content/help/delivery/)"; },
    needAdvice: function(d) { return "アドバイスをご希望ですか？"; },
    needAdviceCTA: function(d) { return "カスタマーケアまでご連絡ください"; },
    finalSaleNotification: function(d) { return "ファイナルセール - この商品は返品できません"; },
    genericMessage: function(d) { return ""; },
    Brand: function(d) { return "ブランド"; },
    Illustrative: function(d) { return "例"; },
    productTitle: function(d) { return "アイテム"; }
  },
  considered: {
    badge: function(d) { return "サステナビリティ"; },
    consideredAccordion: function(d) { return "より多くのお客様に責任あるファッションアイテムをお届けする取り組みの一環として、THE OUTNETではこのアイテムをサステナビリティエディットとしてご紹介しています。"; },
    actionText: function(d) { return "詳細を見る"; },
    href: function(d) { return "/editorial/our-considered-pledge"; },
    consideredAttributesTitle: function(d) { return "サステナビリティアイテムである理由"; },
    consideredDelivery: function(d) { return "يعدّ خيار التوصيل هذا الأقل على الإطلاق بشأن الانبعاثات الكربونية في الوقت الحالي"; },
    consideredFilters: function(d) { return "サステナビリティをすべて見る"; }
  },
  colourAndSize: {
    colour: function(d) { return "カラー"; },
    size: function(d) { return "サイズ"; },
    button1: function(d) { return "こんにちは"; },
    button2: function(d) { return "こんにちは"; },
    line1: function(d) { return "こんにちは"; },
    line2: function(d) { return "こんにちは"; }
  },
  pagination: {
    first: function(d) { return "最初のページ"; },
    previous: function(d) { return "前へ"; },
    next: function(d) { return "次へ"; },
    last: function(d) { return "最後のページ"; },
    status: function(d) { return d.currentPage + " / " + d.totalPages; }
  },
  contactUsCTA: {
    personalShopper: {
      title: function(d) { return "ウェイティングリストへの登録をご希望される場合はパーソナルショッピングチームにご連絡ください"; },
      titleAssignedPS: function(d) { return "ウェイティングリストへの登録をご希望される場合は" + d.name + "にご連絡ください"; },
      emailLabel: function(d) { return "Eメール"; },
      emailStructure: {
        subject: function(d) { return d.name + "のウェイティングリスト登録を希望します"; },
        body: function(d) { return "この商品のウェイティングリスト登録を希望します:" + d.url; }
      }
    },
    sizeAndFit: {
      title: function(d) { return "Still not sure what size to purchase?"; },
      titleEip: function(d) { return "Our Personal Shopping Team is on hand to provide detailed product information."; },
      titlePersonalShopper: function(d) { return "Your Personal Shopper is on hand to provide detailed product information."; },
      emailLabel: function(d) { return "Email"; },
      emailStructure: {
        subject: function(d) { return "I would like your advice for " + d.name; },
        body: function(d) { return "I am still not sure about sizing for this product: " + d.url; }
      }
    },
    badge: function(d) { return "パーソナルショッパーに連絡する"; },
    eip: {
      soldOutOnline: {
        title: function(d) { return "代わりの商品をお探しの際はパーソナルショッピングチームにご連絡ください"; },
        titleAssignedPS: function(d) { return "代わりの商品をお探しの際は" + d.name + "にご連絡ください"; },
        emailLabel: function(d) { return "Eメール"; },
        emailStructure: {
          subject: function(d) { return "完売した" + d.name + "に代わる商品を探しています"; },
          body: function(d) { return "完売した商品に代わる商品を探しています:" + d.url; }
        }
      },
      notStockedOnline: {
        title: function(d) { return "購入を希望される際はパーソナルショッピングチームにご連絡ください"; },
        titleAssignedPS: function(d) { return "購入を希望される際は" + d.name + "にご連絡ください"; },
        emailLabel: function(d) { return "Eメール"; },
        emailStructure: {
          subject: function(d) { return d.name + "の購入を希望します"; },
          body: function(d) { return "購入を希望します:" + d.url; }
        }
      },
      buyableFalse: {
        title: function(d) { return "購入を希望される際はパーソナルショッピングチームにご連絡ください"; },
        titleAssignedPS: function(d) { return "購入を希望される際は" + d.name + "にご連絡ください"; },
        emailLabel: function(d) { return "Eメール"; },
        emailStructure: {
          subject: function(d) { return d.name + "の購入を希望します"; },
          body: function(d) { return "購入を希望します:" + d.url; }
        }
      },
      shippingRestricted: {
        title: function(d) { return "注文について質問がございましたら､パーソナルショッピングチームにご連絡ください"; },
        titleAssignedPS: function(d) { return "注文について質問がございましたら" + d.name + "にご連絡ください"; },
        emailLabel: function(d) { return "Eメール"; },
        emailStructure: {
          subject: function(d) { return d.name + "の注文について質問があります"; },
          body: function(d) { return "注文について質問があります:" + d.url; }
        }
      },
      "default": {
        title: function(d) { return "サイズ選びでお困りの場合やお探しのサイズが見つからない場合はパーソナルショッピングチームまでご連絡ください"; },
        titleAssignedPS: function(d) { return "サイズ選びでお困りの場合やお探しのサイズが見つからない場合は" + d.name + "までご連絡ください"; },
        emailLabel: function(d) { return "Eメール"; },
        emailStructure: {
          subject: function(d) { return d.name + "のサポートを希望します"; },
          body: function(d) { return "サポートを希望します:" + d.url; }
        }
      },
      badge: function(d) { return "パーソナルショッパーに連絡する"; }
    }
  },
  ctaButtons: {
    goToWishlist: function(d) { return "ウィッシュリストを見る"; },
    addToWishlist: function(d) { return "ウィッシュリストに追加"; },
    addToWishlistLoading: function(d) { return "ウィッシュリストに追加中…"; },
    addToBag: function(d) { return "ショッピングバッグに追加"; },
    goToBag: function(d) { return "ショッピングバッグを見る"; },
    addToBagLoading: function(d) { return "ショッピングバッグに追加中…"; },
    viewShoppingBag: function(d) { return "ショッピングバッグを見る"; },
    viewMoreDetails: function(d) { return "詳細を見る"; }
  },
  price: {
    discountPercentage: function(d) { return d.discountPercentage + "%OFF"; },
    discountPrice: function(d) { return "割引額"; },
    currencyExchange: function(d) { return "(概算 " + d.exchangeCurrency + " " + d.exchangePrice + ")"; },
    taxIncluded: function(d) { return "（税込）"; },
    ddpInformation: function(d) { return "(taxes and duties included)"; },
    wasPriceOriginal: function(d) { return "希望小売価格: " + d.wasPrice; },
    wasPrice: function(d) { return "希望小売価格:"; },
    originalPrice: function(d) { return "元の価格:"; },
    priceInformation: {
      title: function(d) { return "価格表示について"; },
      subtitle: function(d) { return "THE OUTNETでは以下のように価格を表示しています:"; },
      descriptionRRPWithoutMinimumMessage: function(d) { return "**1. 現在の価格:**\nTHE OUTNETのアプリおよびウェブサイト限定の販売価格\n\n**2. 希望小売価格:**\n商品に付随する「希望小売価格」は、日本市場における該当商品の希望小売価格です。\n\n該当商品の希望小売価格が日本市場で入手できない場合は、英国における同一商品の希望小売価格を現地通貨（円）に換算し、日本市場において該当商品に近しい商品と整合するように調整した価格となります。\n\n[詳しく見る](" + d.link + ")"; },
      descriptionOriginalPriceWithoutMinimumMessage: function(d) { return "**1. 現在の価格:**\nTHE OUTNETのアプリおよびウェブサイト限定の販売価格\n\n**2. 元の価格:**\nTHE OUTNETのアプリおよびウェブサイトに最初に掲載された価格\n\n[詳しく見る](" + d.link + ")"; }
    }
  },
  productListing: {
    unselectAll: function(d) { return "チェックをすべてはずす"; },
    allSelected: function(d) { return "すべて"; },
    numberSelected: function(d) { return d.number + " 項目選択されました"; },
    refine: function(d) { return "絞込み"; },
    priceFilter: {
      under: function(d) { return d.price; },
      over: function(d) { return d.price; }
    },
    apply: function(d) { return "適用する"; },
    clearFilters: function(d) { return "すべてクリア"; },
    sortBy: function(d) { return "並べ替え"; },
    topDesignersThisWeek: function(d) { return "今週のトップブランド"; },
    azDesigners: function(d) { return "ブランド A-Z"; },
    searchDesigner: function(d) { return "ブランドを検索"; },
    noResultsSearch: function(d) { return "We have found no results for \"" + d.searchTerm + "\". Please try again."; },
    emptyList: function(d) { return select(d.pageType, { MARK_DOWN: "セールは終了いたしました", DESIGNER: "新シーズンの商品が近日入荷予定", SEARCH: d.query + "の検索内容に一致する結果がありません", other: "アイテムが見つかりませんでした" }); },
    emptyListCopy: function(d) { return select(d.pageType, { SEARCH: "再度お試しいただくか、以下よりショッピングをお楽しみください", other: "" }); },
    emptyListGoTo: function(d) { return select(d.pageType, { other: "" }); },
    loadMore: function(d) { return "さらに見る"; },
    youHaveViewed: function(d) { return "商品数: " + d.totalProducts + "点中" + d.totalNumberOfViewedProducts + "点を表示"; },
    loadPrevious: function(d) { return "戻る"; },
    saleToggle: function(d) { return select(d.pageType, { DESIGNER: "ショップ " + d.designerName + " セール", other: "ショップ" + d.designerName }); },
    notifyTitle: function(d) { return "申し訳ございません"; },
    continueLink: function(d) { return "Just Inを見る"; },
    wishList: {
      title: function(d) { return "ウィッシュリストに追加されました"; },
      subtitle: function(d) { return "お客様のアカウントから、お気に入りアイテムをいつでもご覧いただけます"; },
      goToWishlist: function(d) { return "ウィッシュリストを見る"; }
    }
  },
  contentHeader: {
    viewMoreCopy: function(d) { return "もっと見る"; },
    sale: function(d) { return "セール"; }
  },
  collapsableContent: {
    viewMore: function(d) { return "もっと"; },
    viewLess: function(d) { return "もっと少なく"; }
  },
  sizes: {
    sizeLabel: function(d) { return "サイズ"; },
    oneSizeLabel: function(d) { return "ワンサイズ"; },
    initialValue: function(d) { return "サイズを選択してください"; },
    sizeConversion: function(d) { return "サイズ" + d.sizeLabel + "は" + d.localLanguageType + "サイズ" + d.localSizeValue + "に相当します"; },
    sizeConversionModal: function(d) { return "サイズ**" + d.sizeLabel + "**" + select(d.isSelected, { true: "は**" + d.preferredSize + "**に相当します", other: "は" + d.preferredSize + "に相当します" }); },
    sizeGuide: {
      viewProductMeasurements: function(d) { return "サイズガイド"; },
      viewSizeGuide: function(d) { return "サイズガイド"; },
      measuringGuide: function(d) { return "サイズガイド"; },
      title: function(d) { return "サイズガイド"; },
      sizeMeasurementsTitle: function(d) { return "サイズガイド"; },
      sizeMeasurementsDetails: function(d) { return "THE OUTNETのサイズ＆フィットチームが各アイテムのサイズを計測しています"; },
      sizeConversionsTitle: function(d) { return "サイズについて"; },
      sizeConversionsDetails: function(d) { return "サイズ選びにお困りの際はこちらをご参照ください"; },
      slideToScroll: function(d) { return "もっと見る"; },
      noFurtherInfo: function(d) { return "サイズに関するこれ以上の情報はありません"; },
      unavailable: function(d) { return "ご利用の国/地域でのお取り扱いなし"; },
      cm: function(d) { return "cm"; },
      "in": function(d) { return "in"; },
      compareSize: {
        text: function(d) { return ""; },
        subText: function(d) { return ""; }
      },
      inStock: function(d) { return "在庫あり"; },
      lowStock: function(d) { return "残りわずか"; },
      oneLeft: function(d) { return "最後の1点"; },
      outOfStock: function(d) { return "在庫なし"; }
    },
    watchSizeGuide: {
      title: function(d) { return ""; }
    }
  },
  seo: {
    azdesigners: {
      title: function(d) { return "ブランド名で探す | THE OUTNET"; },
      description: function(d) { return ""; },
      keywords: function(d) { return ""; }
    },
    pdpMarkup: {
      nbColours: function(d) { return plural(d.copy, 0, en, { "1": " お取り扱いカラーは" + d.color1 + "。素材は", "2": " お取り扱いカラーは" + d.color1 + "と" + d.color2 + "。素材は", other: " " + number(d.copy, "copy") + "色で展開。素材は" }); },
      productDescription: function(d) { return d.color + "の" + d.name + "。サイズは" + d.size + "。" + select(d.material, { undefined: "", other: "素材は" + d.material + "。" }); }
    },
    plpMarkup: {
      name: function(d) { return select(d.category, { undefined: d.designerName, other: d.designerName + " " + d.category }); }
    }
  },
  error: {
    notFound: function(d) { return "申し訳ございません。お探しのページが見つかりませんでした"; },
    unknownError: function(d) { return "申し訳ございません。エラーが発生しました"; },
    goBack: function(d) { return "戻る"; }
  },
  retry: {
    title: function(d) { return "申し訳ございません。ページを表示できませんでした\n"; },
    retrynow: function(d) { return "もう一度試す"; },
    timetoretry: function(d) { return d.seconds + "秒後に再接続します…"; },
    retryingnow: function(d) { return "再接続しています"; }
  },
  accordionTitles: {
    editorsNotes: function(d) { return "商品説明"; },
    sizeAndFit: function(d) { return "サイズ＆フィット"; },
    technicalSpecification: function(d) { return ""; },
    detailsAndCare: function(d) { return "商品詳細＆お手入れ方法"; },
    technicalDescription: function(d) { return "商品詳細"; }
  },
  accordionIds: {
    editorsNotes: function(d) { return "EditorNotes"; },
    sizeAndFit: function(d) { return "SizeAndFit"; },
    detailsAndCare: function(d) { return "Details"; },
    technicalDescription: function(d) { return "DetailsAndCare"; }
  },
  sizeAndFit: {
    sizeDetails: function(d) { return select(d.slash, { slash: " / " + d.label + d.uom, other: d.label + d.uom }); }
  },
  detailsAndCare: {
    imported: function(d) { return "この商品は輸入品です"; },
    madeIn: function(d) { return d.madeIn + "製"; }
  },
  notifications: {
    PAGE_NOT_AVAILABLE: {
      title: function(d) { return "申し訳ございません"; },
      message: function(d) { return "こちらのセールへはアクセスいただけません。THE OUTNETには人気アイテムが続々入荷中です。引き続きショッピングをお楽しみください。"; }
    },
    PAGE_CLOSED: {
      title: function(d) { return "申し訳ございません"; },
      message: function(d) { return "プライベートセールは終了しました。THE OUTNETには人気アイテムが続々入荷中です。引き続きショッピングをお楽しみください。"; }
    },
    PAGE_SOON: {
      title: function(d) { return "プライベートセールについて"; },
      message: function(d) { return "まもなくスタートしますので、今しばらくお待ちください。THE OUTNETには人気アイテムが続々入荷中です。引き続きショッピングをお楽しみください。"; }
    },
    ADD_TO_BAG_MESSAGE_ERROR: function(d) { return "ショッピングバッグに追加できませんでした"; },
    authToAdd: function(d) { return "このアイテムをウィッシュリストに追加するには、サインインまたは登録してください"; },
    promoPriceSuccess: function(d) { return "プロモコードがコピーされました"; },
    errors: function(d) { return select(d.error, { ADD_TO_WISHLIST_NO_SIZE_SELECTED_ERROR: "サイズをお選びください", ERR_WISH_LIST_NOT_EXISTS: "このウィッシュリストは削除されています。別のウィッシュリストに商品を追加してください", ERR_WISH_LIST_MAX_WISH_LIST_ITEMS_REACHED: "保存可能な商品数を超えています。ウィッシュリストにて商品の数量を変更し､もう一度お試しください", ERR_SKU_ALREADY_EXISTS: "この商品はすでに保存されています", NO_SIZE_SELECTED_ERROR: "サイズをお選びください", TEMPORARY_ADD_TO_CART_ERROR: "申し訳ございません。ショッピングバッグに商品が入りませんでした。もう一度お試しください", ADD_TO_CART_IDENTITY_GENERIC_ERROR: "申し訳ございません。ショッピングバッグに商品が入りませんでした。もう一度お試しください", ADD_TO_CART_GENERIC_ERROR: "申し訳ございません。ショッピングバッグに商品が入りませんでした。もう一度お試しください", CART_ITEM_OUT_OF_STOCK: "申し訳ございません。この商品は完売しました", CART_ITEM_INSUFFICIENT_STOCK: "申し訳ございません。この商品は在庫がございません", CART_ORDER_LINE_QTY_LIMIT: "申し訳ございません。ショッピングバッグに入れられる商品数を超えています", CART_ORDER_LINES_LIMIT: "申し訳ございません。ショッピングバッグに追加できる商品数を超えています", CWXFR0268E: "", NO_UBER_TOKEN_ERROR: "", other: "申し訳ございません、 エラーが発生しました。後ほどもう一度お試しください" }); }
  },
  promoPrice: {
    codeDescription: function(d) { return "プロモコード"; },
    promotionalPrice: function(d) { return "セール価格"; }
  },
  shopMore: {
    title: function(d) { return "もっと見る"; }
  },
  wearItWith: {
    heading: function(d) { return "コーディネートアイテム"; }
  },
  youMayAlsoLike: {
    heading: function(d) { return "おすすめアイテム"; }
  },
  soldOutReducedPage: {
    heading: function(d) { return "類似商品をチェック"; }
  },
  recentlyViewed: {
    heading: function(d) { return "最近チェックしたアイテム"; }
  },
  moreByThisDesigner: {
    heading: function(d) { return "More By This Designer"; }
  },
  noResultsSearchPage: {
    dividerHeading: function(d) { return "お客様へのおすすめアイテム"; }
  },
  designers: {
    pageName: function(d) { return "ブランド"; },
    favorite: function(d) { return "Favorite Designer"; },
    mens: function(d) { return "メンズ"; },
    womens: function(d) { return "レディース"; }
  },
  designersWithSale: {
    pageName: function(d) { return "セール中のブランド"; }
  },
  deliveryAndReturns: {
    title: function(d) { return "配送と返品"; },
    description: function(d) { return "配送方法と返品･交換方法について詳しく見る"; },
    shippingModesIntro: function(d) { return "配送方法"; },
    shippingMode: function(d) { return "国際配送システム"; },
    returnsInfo: function(d) { return "商品の返品･交換可能期間は到着日を含めて14日以内です"; },
    findOutMoreLink: function(d) { return "詳しく見る"; }
  },
  errors: {
    empty: function(d) { return "This field is required"; },
    invalid: function(d) { return "Enter a valid " + d.field; }
  },
  accountUtility: {
    signupMessage: function(d) { return "\nSign up for our emails to be notified about future sales and other upcoming events."; },
    submit: function(d) { return "Submit"; },
    emailLabel: function(d) { return "Email Address"; }
  },
  recommendations: {
    viewSimilarItems: function(d) { return "もっと見る"; }
  },
  manufacturerDetails: {
    title: function(d) { return "Manufacturing Details"; },
    subtitle: function(d) { return "MANUFACTURER INFORMATION"; },
    button: function(d) { return "View manufacturing details"; },
    content: function(d) { return "We have no information on this product at the moment, but we're working to include them in the near future.\n\nPlease check back later for updates."; }
  }
}